module.exports = __webpack_public_path__ + "img/Sibiu_b_kl.7cbbca98.jpg";